import { render, staticRenderFns } from "./CategoryCardItem.vue?vue&type=template&id=10d6feca&"
import script from "./CategoryCardItem.vue?vue&type=script&lang=js&"
export * from "./CategoryCardItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCardItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports